module.exports = __webpack_public_path__ + "img/BuyFlight.a00b7b7b.png";